export enum CustomerStatus {
    ACTIVE = "Active",
    INACTIVE = "Inactive"
}